import {ApplicationTypeConstants} from './../../services/warmup/warmup.service';
import {ApplicationValue} from 'app/services/warmup/application-type.model';
import {Pipe, PipeTransform, OnInit} from "@angular/core/";
import {WarmUpService} from 'app/services/warmup/warmup.service';
import {Observable} from 'rxjs/Observable';
import {EntityRelationsService} from '../../entities/relations/entity-relations.service';


@Pipe({
  name: 'RelationNameFromId'
})

export class RelationNamePipe implements PipeTransform, OnInit {
  relationTypes: ApplicationValue[];

  transform(value: number): string {
    let relation = this.getSelectedRelationName(value);
    if (relation) {
      return relation.name;
    } else {
      return "";
    }
  }

  constructor(private entityRelationsService: EntityRelationsService) {
  }

  ngOnInit() {
    // this.loadRelationTypes();
  }

  loadRelationTypes() {
    const relations = this.entityRelationsService.loadRelationTypes();
    if (relations instanceof Observable) {
      relations.subscribe(
        response => {
          this.relationTypes = response.values;
        }
      );
    } else {
      this.relationTypes = relations;
    }
  }

  getSelectedRelationName(relatoinId: number) {
    this.loadRelationTypes();
    return this.relationTypes.find(relation => relation.id === relatoinId);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/relationName.pipe.ts